import { gql } from '@apollo/client';
import { SESSION_FIELDS } from "./session";
export const COURSE_FIELDS = gql`
  fragment CourseFields on CourseDto {
    id
    nameCourse
    codeCourse
    codeOfficial
    blockName
    qualificationType
  }
`;
export const COURSE_SESSIONS_FIELDS = gql`
  ${SESSION_FIELDS}
  fragment CourseSessionsFields on CourseSessionsDto {
    courseId
    sessions {
      ...SessionFields
    }
  }
`;
export const ENROLLMENT_COURSE_FIELDS = gql`
  fragment EnrollmentCourseDTO on PortalEnrollmentCourseDTO {
    state
    courseId
    courseName
    courseDescription
    courseObjective
    courseMoodleId
    courseCategory
    courseDuration
    courseImage
    stateLabel
    initialDate
    finalDate
    remainingDays
  }
`;